import { Alert } from '@commenda/kakashi';
import { TAX_CODE_REFERENCE_URL } from '../common/constants';

const TaxCodeReferenceLinkBanner = ({ className }: { className?: string }) => {
  return (
    <Alert
      _className={className}
      variant="info"
      title="Access our tax code database"
      description="Using accurate tax codes helps ensure compliance and improves tax calculations. Check out our database for quick reference."
      action={{
        label: 'View database',
        onClick: () => {
          window.open(
            TAX_CODE_REFERENCE_URL,
            'TaxCodeReference',
            'width=1000,height=800,left=200,top=200'
          );
        },
        variant: 'link',
      }}
    />
  );
};

export default TaxCodeReferenceLinkBanner;
